/**
 * HerndonMap Survey Configuration
 * Phase 2: Dreams-Only Map - Reopened July 2026
 */

// Re-open the survey for Phase 2 (dreams-only)
export const SURVEY_OPEN = true;

// Show archived comments from Phase 1 (with toggle)
export const SHOW_OLD_COMMENTS = true;

// Only new comments use "dreams_2" type
export const NEW_COMMENT_TYPE = "dreams_2";

export const PHASE_2_MESSAGE = "We're reopening the map to hear your dreams for Herndon's future! Share what you'd love to see happen in our community.";
